import { Box } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";

import { GMNMonitoringPointTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";

import { useGmnUiSchema } from "../../schema/gmn-ui-schema";

import {
  GmnMeasuringPointTable,
  RegistrationGmnMeasuringPoint,
} from "./components/gmn-measuring-point-table";
import { getGmnMeasuringPointSchema } from "./schema/gmn-measuring-point-schema";

export function GmnMeasuringPointForm() {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const [measuringPoints, setMeasuringPoints] = useState<RegistrationGmnMeasuringPoint[]>([]);

  const { formData, handleChange } = useBrostarFormDataStorage<GMNMonitoringPointTask>({
    key: "gmnMeasuringPoint",
    task: undefined,
  });

  useEffect(() => {
    const file = formData?.measuringPointsFile;

    if (!file || !(file instanceof Blob)) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const workbook = XLSX.read(event.target?.result, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData: RegistrationGmnMeasuringPoint[] = XLSX.utils.sheet_to_json(sheet);
      setMeasuringPoints(sheetData);
    };
    reader.readAsBinaryString(file);
  }, [formData?.measuringPointsFile]);

  const uiSchema = useGmnUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getGmnMeasuringPointSchema(undefined), []);

  const onSubmit = async () => {
    if (!formData) return;
    await api.createGmnMeasuringPoints(formData);
    // FUTURE: Implement upload task editing
    // if (oldUploadTask?.uuid) await api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <Box mb={10}>
      <BrostarForm
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        onChange={handleChange}
        onSubmit={onSubmit}
        uploadTask={undefined}
      />
      <Box h="400px" mb={10}>
        <GmnMeasuringPointTable measuringPoints={measuringPoints} />
      </Box>
    </Box>
  );
}
